// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupChatInfo__content-b85245 {
  display: flex;
  flex-direction: column;
  margin-inline-start: 12px;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
}

.GroupChatInfo__title-wrapper-f06732 {
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;
}

.GroupChatInfo__title-e5e0ab {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GroupChatInfo__members-count-c56dfb {
  text-align: left;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}

.GroupChatInfo__secureIcon-e2b7c1 {
  margin-inline-end: 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/GroupChatInfo/GroupChatInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  margin-inline-start: 12px;\n  justify-content: space-between;\n  align-items: flex-start;\n  overflow: hidden;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.members-count {\n  text-align: left;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n\n.secureIcon {\n  margin-inline-end: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `GroupChatInfo__content-b85245`,
	"title-wrapper": `GroupChatInfo__title-wrapper-f06732`,
	"titleWrapper": `GroupChatInfo__title-wrapper-f06732`,
	"title": `GroupChatInfo__title-e5e0ab`,
	"members-count": `GroupChatInfo__members-count-c56dfb`,
	"membersCount": `GroupChatInfo__members-count-c56dfb`,
	"secureIcon": `GroupChatInfo__secureIcon-e2b7c1`
};
module.exports = ___CSS_LOADER_EXPORT___;
